import { useQueries } from "react-query";
import { PostList, PostListSchema } from "./types/postList.types";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithDetailedLog } from "src/utils/zodErrorLogger";

export const getPackagingPostsKey = "getPackagingPosts" as const;
export const getPackagingsPostsKey = "getPackagingsPosts" as const;

export type PackagingPostListInner = {
    packagingId: number;
    posts: PostList[];
};
export type PackagingPostListQuery = PackagingPostListInner | undefined;
export type PackagingPosts = {
    isReady: boolean;
    packagingPosts: PackagingPostListQuery[];
};

export const fetchPackagingPosts = async (packagingId: number) => {
    const url = `/api/packagings/${packagingId}/ssq-posts`;

    const params: { [key: string]: string | string[] } = {
        dimensions: ["main"],
    };

    const response = await loggedInApiCall.get(url, {
        headers: {
            Accept: "application/json",
        },
        params: params,
    });
    const posts = response.data;
    const data = zodParseWithDetailedLog(posts, PostListSchema.array(), {
        operation: "GET",
        endpoint: "/packagings/:id/ssq-posts",
    });
    return data;
};

export const useGetPackagingsPosts = (packagingIds: number[]): PackagingPosts => {
    const queries = useQueries(
        packagingIds.map((packagingId) => ({
            queryFn: async () => {
                const packagingPosts = await fetchPackagingPosts(packagingId);

                const result: PackagingPostListInner = {
                    packagingId,
                    posts: packagingPosts,
                };

                return result;
            },
            queryKey: [getPackagingsPostsKey, packagingId],
        })),
    );

    const hasAllLoaded = queries.every((query) => query.status === "error" || query.status === "success");

    if (hasAllLoaded === false) {
        return {
            isReady: false,
            packagingPosts: [],
        };
    }

    const allPosts = queries.map((query) => {
        const data = query.data;
        return data;
    });

    return {
        isReady: true,
        packagingPosts: allPosts,
    };
};
